module.exports = __webpack_public_path__ + "static/me-696c4a4569f761ac61d60b1123b49785.jpg";